module.exports = __webpack_public_path__ + "img/bg_report.61a3477c.jpg";